import { ElementType, useMemo } from 'react';

import { ICustomIcon } from '@app-types/custom-icons';

import { BigIconVariant } from '@components/big';
import { ByouIconVariant } from '@components/byou';

export enum SegmentControlTitleVariant {
    BIG = 'big',
    BYOU = 'byou',
}

interface SegmentControlTitleProps<T extends BigIconVariant | ByouIconVariant> {
    icon: ElementType<ICustomIcon<T>>;
    variant: SegmentControlTitleVariant;
    active?: boolean;
}

export function SegmentControlTitle<T extends BigIconVariant | ByouIconVariant>({
    icon: Icon,
    active,
    variant,
}: Readonly<SegmentControlTitleProps<T>>) {
    const variantMapping: Record<
        SegmentControlTitleVariant,
        { active: ICustomIcon<T>['variant']; inactive: ICustomIcon<T>['variant'] }
    > = {
        [SegmentControlTitleVariant.BIG]: {
            active: BigIconVariant.WHITE as ICustomIcon<T>['variant'],
            inactive: BigIconVariant.INFO as ICustomIcon<T>['variant'],
        },
        [SegmentControlTitleVariant.BYOU]: {
            active: ByouIconVariant.WHITE as ICustomIcon<T>['variant'],
            inactive: ByouIconVariant.PRIMARY as ICustomIcon<T>['variant'],
        },
    };

    const iconVariant = useMemo(() => {
        const { active: activeVariant, inactive: inactiveVariant } = variantMapping[variant];
        return active ? activeVariant : inactiveVariant;
    }, [active, variant, variantMapping]);

    return <Icon variant={iconVariant} />;
}
